import { render, staticRenderFns } from "./integralOrders.vue?vue&type=template&id=00c76ace&scoped=true&"
import script from "./integralOrders.vue?vue&type=script&lang=js&"
export * from "./integralOrders.vue?vue&type=script&lang=js&"
import style0 from "./integralOrders.vue?vue&type=style&index=0&id=00c76ace&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c76ace",
  null
  
)

export default component.exports